import React from 'react';
import { Clock } from 'lucide-react';
import { usePublicData } from '../lib/publicData';
import catalogContract from '../generated/catalog-contract.json';

export const StudioHours = ({ id, compact = false }) => {
  const initial = usePublicData();
  const hours = initial.studio_hours || catalogContract.studio_hours;
  if (!hours) return null;
  return <section data-testid={`${id}-studio-hours`} className={compact ? 'mt-6 text-sm' : 'my-8 border-y border-white/15 py-5 text-sm'}>
    <h2 data-testid={`${id}-hours-title`} className="text-base font-medium flex items-center gap-2 mb-3"><Clock size={16} aria-hidden="true"/>Horaires du studio</h2>
    <dl className="space-y-2 text-white/80">{hours.rows.map(row => <div key={row.id} className="flex flex-wrap gap-x-3 gap-y-1" data-testid={`${id}-hours-${row.id}`}>
      <dt className="font-medium">{row.days}</dt><dd>{row.hours}</dd>
    </div>)}</dl>
    {!compact && <p className="mt-3 text-white/70" data-testid={`${id}-hours-note`}>{hours.note}</p>}
  </section>;
};